import React from "react";
import { useGetPublicSessions } from "../api/session";
import { useGetPublicEvent } from "../api/event";
import { useLocation, useParams } from "react-router-dom";
import LoadingPage from "../components/common/LoadingPage";
import NotFound from "./NotFound";
import { Flex, Image, Title } from "@mantine/core";
import congrsLogo from "../assets/logo-02.svg";
import dayjs from "dayjs";
import SessionCards from "../components/Cards/SessionCards";

function PublicSessions() {
  // Get search params
  const location = useLocation();
  const { slug } = useParams();

  const searchParams = new URLSearchParams(location.search);

  const {
    data: event,
    isPending: isEventPending,
    isError: isEventError,
  } = useGetPublicEvent(slug);

  const params = {
    eventId: event?.id,
    locationId: searchParams.get("locationId"),
    dateId: searchParams.get("dateId"),
  };

  const { data, isPending } = useGetPublicSessions(params);

  if (!slug) {
    return <NotFound />;
  }

  if (isEventPending) {
    return <LoadingPage />;
  }

  if (isEventError || !event) {
    return <NotFound />;
  }

  if (isPending) {
    return <LoadingPage />;
  }

  const groupedSessions = data?.sessions.reduce((acc, session) => {
    const date = dayjs(session.starting).format("YYYY-MM-DD");

    if (!acc[date]) {
      acc[date] = Object.create(null);
    }

    if (!acc[date][session.location.name]) {
      acc[date][session.location.name] = [];
    }

    acc[date][session.location.name].push(session);
    return acc;
  }, {});

  // Sort dates chronologically
  const sortedDates = Object.keys(groupedSessions || {}).sort((a, b) =>
    dayjs(a).diff(dayjs(b))
  );

  // Sort sessions within each location by starting time
  sortedDates.forEach((date) => {
    Object.keys(groupedSessions[date]).forEach((locationId) => {
      groupedSessions[date][locationId].sort((a, b) =>
        dayjs(a.starting).diff(dayjs(b.starting))
      );
    });
  });

  return (
    <Flex direction="column" px="md">
      <Flex direction="row" justify="space-between" align="center">
        <Image
          src={congrsLogo}
          alt="RoundCube logo"
          style={{ maxHeight: "150px" }}
        />
        {data?.event && (
          <Title style={{ textAlign: "right" }}>{data.event.name}</Title>
        )}
      </Flex>

      {sortedDates.map((date) => {
        return (
          <Flex direction="column" gap="sm" key={date} mb="lg">
            <Title order={2}>
              {dayjs(date).format("dddd - MMMM DD, YYYY")}
            </Title>
            {Object.keys(groupedSessions[date]).map((locationId) => {
              return (
                <Flex direction="column" gap="sm" key={locationId}>
                  <Title order={3}>{locationId}</Title>
                  {groupedSessions[date][locationId].map((session) => {
                    return <SessionCards session={session} />;
                  })}
                </Flex>
              );
            })}
          </Flex>
        );
      })}
    </Flex>
  );
}

export default PublicSessions;
